import { render, staticRenderFns } from "./VeJwCjChangeStatus.vue?vue&type=template&id=b8be18a6"
import script from "./VeJwCjChangeStatus.vue?vue&type=script&lang=js"
export * from "./VeJwCjChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports